import React, { useState, useEffect, useRef, useCallback, useMemo } from "react"
import Loading from "../../../components/Loading"
import { Document, Page, pdfjs } from "react-pdf"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import { throttle } from "throttle-debounce"
import { Waypoint } from "react-waypoint"

import "react-pdf/dist/Page/AnnotationLayer.css"

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const ssr = typeof window === "undefined"

const ReportView = (props) => {
  const { match, location } = props

  const [pagesLoaded, setPagesLoaded] = useState(0)
  const [pageCount, setPageCount] = useState(0)
  const [initialWidth, setInitialWidth] = useState(null)
  const demoReportWrapper = useRef(null)

  const reportId = match.params.productId

  const queryParams = new URLSearchParams(location.search)
  const token = queryParams.get("token")

  const fileURL = useMemo(() => {
    return {
      url: `/demo-products/${reportId}?token=${token}`,
    }
  }, [reportId, token])

  const setInitialSize = useCallback(
    throttle(3000, () => {
      if (demoReportWrapper && demoReportWrapper.current) {
        setInitialWidth(demoReportWrapper.current.getBoundingClientRect().width)
      }
    }),
    []
  )

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setPageCount(numPages)
  }, [])

  const renderMorePages = () => {
    setPagesLoaded(Math.min(pageCount, pagesLoaded + 5))
  }

  const renderPages = () => {
    const pages = []
    for (let i = 0; i < pagesLoaded; i++) {
      pages.push(
        <div className="demo-report-page-container" key={`page_${i}`}>
          <Page loading={<Loading />} width={initialWidth} pageIndex={i} />
          {i === pagesLoaded - 5 && <Waypoint onEnter={renderMorePages} />}
        </div>
      )
    }

    return pages
  }

  useEffect(() => {
    window.addEventListener("resize", setInitialSize)
    setInitialSize()
    return () => {
      window.removeEventListener("resize", setInitialSize)
    }
  }, [])

  useEffect(() => {
    setPagesLoaded(Math.min(pageCount, 10))
  }, [pageCount])

  if (ssr) return null

  return (
    <div className="demo-report-container">
      <div className="demo-report-buttons">
        <Link to={`/interactive-demo?token=${token}`}>
          <span>{"< Go Back"}</span>
        </Link>
      </div>
      <div className="demo-report-wrapper" ref={demoReportWrapper}>
        <Document
          loading={<Loading />}
          file={fileURL}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {renderPages()}
        </Document>
      </div>
    </div>
  )
}

export default withRouter(ReportView)
